<template>
  <!-- Full width div with white background and rounded edges -->
  <div class="w-full bg-white p-4 rounded-lg shadow mb-4">
    <div class="flex flex-wrap items-center justify-between gap-2 p-4">
      <div class="flex flex-wrap gap-2">
        <!-- Status Filter Buttons -->
        <div class="pb-2">
          <ButtonGroup>
            <Button
              label="Quote"
              @click="filterLogistics('quote')"
            />
            <Button
              label="Confirmed"
              @click="filterLogistics('confirmed')"
            />
            <Button
              label="Complete"
              @click="filterLogistics('complete')"
            />
          </ButtonGroup>
        </div>

        <!-- Date Filter Buttons -->
        <div class="pb-2 ml-2">
          <ButtonGroup>
            <Button
              label="Today"
              @click="filterLogistics('today')"
            />
            <Button
              label="3 Day"
              @click="filterLogistics('3day')"
            />
            <Button
              label="Week"
              @click="filterLogistics('week')"
            />
            <Button
              label="Month"
              @click="filterLogistics('month')"
            />
          </ButtonGroup>
        </div>
      </div>

      <div class="flex items-center gap-2 ml-auto">
        <!-- Search Bar -->
        <div class="w-64">
          <IconField>
            <InputIcon class="pi pi-search" />
            <InputText
              id="search"
              v-model="searchValue"
              type="search"
              class="pl-4 w-full"
              @change="doSearch()"
            />
          </IconField>
        </div>

        <!-- Add Button -->
        <div>
          <SplitButton
            label="Add"
            icon="pi pi-plus"
            severity="secondary"
            :model="items"
            raised
            @click="addProjectModal()"
          />
        </div>
      </div>
    </div>
  </div>

  <!-- DataTable Section -->
  <div class="flex-auto bg-white rounded-lg shadow">
    <DataTable
      :value="logistics"
      sort-field="name"
      scrollable
      scroll-height="625px"
    >
      <template #empty>
        <div class="flex flex-wrap items-center justify-between gap-2 p-4">
          <p>No Transport Requests have been found.</p>
        </div>
      </template>

      <template #footer />
      <Column
        field="name"
        header="Project Name"
        sortable
      />
      <Column
        field="vehicleType"
        header="Vehicle Type"
        sortable
      />
      <Column
        field="transportType"
        header="Transport Type"
        sortable
      />
      <Column
        field="startTime"
        header="Start"
        sortable
      />
      <Column
        field="endTime"
        header="End"
        sortable
      />
      <Column
        field="postcode"
        header="Postcode"
        sortable
      />
      <Column
        field="assignedReg"
        header="Assigned Vehicle"
        sortable
      />
      <Column
        field="status"
        header="Status"
        sortable
      >
        <template #body="slotProps">
          <Badge
            :value="slotProps.data.status"
            :severity="transportSeverity(slotProps.data.status)"
          />
        </template>
      </Column>
      <Column
        field="projectManager"
        header="Project Manager"
        sortable
      />
    </DataTable>
  </div>
</template>

<script setup>
//Primevue Imports


import { ref, onMounted } from 'vue';

import { createTransport } from '@/data/faker'
import { transportSeverity } from '@/shared/DataTableFunctions';

const logistics = ref()
const searchValue = ref('');
const items = [{ label: 'Service' }, { label: 'Contact' }, { label: 'Company' }, { label: 'Venue' },]
const doSearch = () => {
    console.log('searching')
    if (searchValue.value.length > 3) {
        console.log(searchValue.value)
    }

}

// Populate contacts when the component is mounted
onMounted(() => {
    logistics.value = createTransport(100); // Generate 100 contacts
});


//Filter contacts based on the filter button applied above
const filterLogistics = (filter) => {
    console.log(filter)
}
//Show the Add contact Modal
const addProjectModal = () => { }
</script>
